import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { KeepAlive } from 'react-keep-alive';

import MapWrap from "@/views/MapWrap";
import Record from "@/views/Record";
import Faq from "@/views/Faq";
import About from "@/views/About";
import Dev from "@/views/Dev";
import Donate from "@/views/Donate";

export default function Router() {
    return (
        <Switch>
            <Route path="/" exact render={() => <Redirect to="/map" />} /> ,
            <Route exact path="/map">
                <KeepAlive name="map">
                    <MapWrap />
                </KeepAlive>
            </Route> ,
            {/* <Route path="/" exact render={() => <Redirect to="/map" />} /> ,
            <Route exact path="/map" component={MapWrap}></Route> , */}
            <Route exact path="/record" >
                <KeepAlive name="record">
                    <Record />
                </KeepAlive>
            </Route> ,
                <Route exact path="/chaxun" >
                <KeepAlive name="chaxun"><Record /></KeepAlive>
            </Route> ,
            <Route exact path="/donate" >
                <KeepAlive name="donate">
                    <Donate />
                </KeepAlive>
            </Route> ,
            <Route exact path="/about" >
                <KeepAlive name="about">
                    <About />
                </KeepAlive>
            </Route> ,
            <Route exact path="/faq" >
                <KeepAlive name="faq">
                    <Faq />
                </KeepAlive>
            </Route> ,
            <Route exact path="/dev" >
                <KeepAlive name="dev">
                    <Dev />
                </KeepAlive>
            </Route> ,
        </Switch>
    );
}
